var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"nav-icon",style:({
    backgroundImage: ("url(" + _vm.defaultIcon + ")")
  }),attrs:{"src":_vm.navIcon,"alt":"","onload":"this.style.background = 'none'"}})}
var staticRenderFns = []

export { render, staticRenderFns }